/* Carrito (UpCart): no ofrecer la ampolleta a quien ya la recibe de regalo.
   El PACK 3 MESES con suscripcion lleva la ampolleta de regalo en el primer
   envio, asi que venderle otra por $299 en las recomendaciones del carrito no
   tiene sentido. En pago unico NO va de regalo, y ahi se sigue ofreciendo.

   UpCart pinta el carrito por su cuenta y lo repinta cada vez que cambia, por
   eso se vigila con un MutationObserver en vez de engancharse a un evento.
   La linea se reconoce por el texto que UpCart muestra: el nombre del pack y
   el nombre del plan de Shopify ("Entregar cada 3 meses, ..."). Si se renombra
   el pack o el plan, hay que cambiar estos dos textos. */
(function () {
  var PACK = 'PACK 3 MESES';
  var PLAN = 'Entregar cada';
  var REGALO = 'Ampolleta';

  function llevaRegalo(popup) {
    var lineas = popup.querySelectorAll('.upcart-product-item');
    for (var i = 0; i < lineas.length; i++) {
      var texto = lineas[i].textContent || '';
      if (texto.indexOf(PACK) !== -1 && texto.indexOf(PLAN) !== -1) return true;
    }
    return false;
  }

  function revisar() {
    var popup = document.getElementById('UpcartPopup');
    if (!popup) return;
    var ocultar = llevaRegalo(popup);
    popup.querySelectorAll('.upcart-upsells-module').forEach(function (modulo) {
      // Solo se toca el bloque si lo que recomienda es la ampolleta: si algun
      // dia se anade otra recomendacion, esa se sigue viendo.
      if ((modulo.textContent || '').indexOf(REGALO) === -1) return;
      modulo.style.display = ocultar ? 'none' : '';
    });
  }

  // setTimeout y no requestAnimationFrame: rAF se congela con la pestana en
  // segundo plano y el aviso se quedaba sin aplicar.
  var pendiente = false;
  function programar() {
    if (pendiente) return;
    pendiente = true;
    setTimeout(function () {
      pendiente = false;
      revisar();
    }, 60);
  }

  new MutationObserver(programar).observe(document.documentElement, { childList: true, subtree: true });
  programar();
})();
